// src/Dashboard/pages/user/Reglements/components/ReglementsKpis.jsx

import React from "react";
import {
  FaCheckCircle,
  FaClock,
  FaCoins,
  FaEuroSign,
  FaFileInvoiceDollar,
} from "react-icons/fa";

import { formatEUR } from "../utils/reglementsUtils";

export default function ReglementsKpis({ stats, loading }) {
  const cards = [
    {
      key: "amountDue",
      label: "À régler",
      icon: FaEuroSign,
      value: formatEUR(stats?.amountDue || 0),
      tone: "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
    },
    {
      key: "toPay",
      label: "Paiements ouverts",
      icon: FaClock,
      value: stats?.toPay ?? 0,
      tone: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    },
    {
      key: "paid",
      label: "Réglés",
      icon: FaCheckCircle,
      value: stats?.paid ?? 0,
      tone: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    },
    {
      key: "installments",
      label: "Échéances",
      icon: FaCoins,
      value: stats?.installments ?? 0,
      tone: "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    },
    {
      key: "total",
      label: "Total lignes",
      icon: FaFileInvoiceDollar,
      value: stats?.total ?? 0,
      tone: "border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-xl font-bold sm:text-2xl">
                {loading ? "…" : card.value}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}